
import { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { useAuth } from '@/lib/auth-context';
import { WidgetGrid } from '@/components/dashboard';
import { useDashboardLayout } from '@/hooks/useDashboardLayout';

export default function AdminPage() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const { widgets, storageKey } = useDashboardLayout();

  // Admin-only page
  useEffect(() => {
    if (user && user.role !== 'admin') {
      navigate('/unauthorized', { replace: true });
    }
  }, [user, navigate]);

  if (!user || user.role !== 'admin') {
    return null;
  }

  return (
    <div className="mx-auto max-w-7xl">
      <WidgetGrid widgets={widgets} storageKey={storageKey} />
    </div>
  );
}
